import { render, staticRenderFns } from "./ConfigColorPicker.vue?vue&type=template&id=2a41380a&scoped=true"
import script from "./ConfigColorPicker.vue?vue&type=script&lang=js"
export * from "./ConfigColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ConfigColorPicker.vue?vue&type=style&index=0&id=2a41380a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41380a",
  null
  
)

export default component.exports